const nanpin = {
  category: '男频其他',
  categoryId: '1111',
  coverList: [
    {
      coverId: 1111001,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#fff',
        smallTitleColor: '#fff',
        smallTitleBackground: '#000',
        color_mask: '#fff',
        font: '庞门正道标题体',
        fontSize: '63',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 44,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/nan/1-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 1111002,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FFFFFF',
        smallTitleColor: '#fff',
        smallTitleBackground: '#322c25',
        color_mask: '#FFFFFF',
        font: '山海手书',
        fontSize: '63',
        strokeColor: '#322c25',
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 220,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/nan/3-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
    {
      coverId: 1111003,
      template: 'horizen_1',
      title: {
        titleText: '',
        color: '#FFFFFF',
        smallTitleColor: '#fff',
        smallTitleBackground: '#1C3343',
        color_mask: '#FFFFFF',
        font: '庞门正道标题体',
        fontSize: '63',
        // strokeColor: "#fff",
        spacing: 0,
      },
      author: {
        authorText: '',
        fontSize: '18',
        color: '#fff',
      },
      padding: 20,
      background: {
        backgroundImage: 'https://raw.githubusercontent.com/lorryrio/godblesslorry.github.io.images/master/images/cover/nan/2-cover.png',
        textBackground: 'linear-gradient(to bottom, transparent 50%, #333046)',
      },
    },
  ],
};

export default nanpin;
